import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-h-full" }
const _hoisted_2 = { class: "pb-8" }
const _hoisted_3 = { class: "mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8" }
const _hoisted_4 = { class: "grid grid-cols-1 items-start gap-4 lg:grid-cols-2 lg:gap-8" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-4 lg:col-span-2" }
const _hoisted_6 = { "aria-labelledby": "profile-overview-title" }
const _hoisted_7 = { class: "overflow-hidden rounded-lg bg-gray-50" }
const _hoisted_8 = { class: "p-6" }
const _hoisted_9 = { class: "sm:flex sm:items-center sm:justify-between" }
const _hoisted_10 = { class: "sm:flex sm:space-x-5" }
const _hoisted_11 = { class: "text-left sm:mt-0 sm:text-left" }
const _hoisted_12 = {
  key: 0,
  class: "text-2xl font-bold text-gray-600 tracking-tighter"
}
const _hoisted_13 = { "aria-labelledby": "quick-links-title" }
const _hoisted_14 = { class: "divide-y divide-gray-200 overflow-hidden rounded-lg bg-gray-200 sm:grid sm:grid-cols-2 sm:gap-px sm:divide-y-0" }
const _hoisted_15 = { class: "flex justify-start items-start" }
const _hoisted_16 = { class: "md:py-2" }
const _hoisted_17 = { class: "text-lg font-medium tracking-tighter" }
const _hoisted_18 = { class: "focus:outline-none" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "flex flex-col" }
const _hoisted_21 = ["href"]

import {
  AcademicCapIcon,
  BanknotesIcon,
  ClockIcon,
  EnvelopeIcon,
  ReceiptRefundIcon,
  UsersIcon
} from '@heroicons/vue/24/outline'
import { computed } from 'vue'
import { useStore } from 'vuex'


export default {
  __name: 'GuidesTab',
  setup(__props) {

const store = useStore()

const name = computed(() => store.state.loggedInUser?.attributes?.user_name)
const handle = computed(() => store.state.loggedInUser?.attributes?.handle)
const nameOrHandle = computed(() => name.value || handle.value)

const cards = [
  {
    icon: BanknotesIcon,
    name: 'Start selling online',
    iconForeground: 'text-yellow-700',
    iconBackground: 'bg-yellow-50',

    actions: [
      { title: 'Create your first store', url: 'https://help.bottle.com/t/83h7kpj/step-1-creating-your-store' },
      { title: 'Add your products', url: 'https://help.bottle.com/t/35hs6rn/step-4-adding-products' },
      {
        title: 'Add your first fulfillment method',
        url: 'https://help.bottle.com/t/x2h7kgh/step-2-creating-fulfillment-methods'
      }
    ]
  },
  {
    icon: UsersIcon,
    name: 'Segment your customers',
    iconForeground: 'text-purple-700',
    iconBackground: 'bg-purple-50',
    actions: [
      { title: 'Get familiar with groups', url: 'https://help.bottle.com/t/g9h7q7l/understanding-groups' },
      { title: 'Build your first group', url: 'https://www.loom.com/share/fec491aa12444be08f0b0dd0308b5fc6' },
      { title: 'Test out tags', url: 'https://www.loom.com/share/fbb8eb7cf1fe44ecb1ca0de9929649e7' }
    ]
  },
  {
    icon: EnvelopeIcon,
    name: 'Text your customers',
    iconForeground: 'text-sky-700',
    iconBackground: 'bg-sky-50',
    actions: [
      { title: 'Send your first text', url: 'https://www.loom.com/share/e35228ffbcde4d6d90876170e0f7d2ad' },
      { title: 'Schedule an automation', url: 'https://www.loom.com/share/d53ce4197f1e4400ab793db80b3e3745' },
      {
        title: 'Setup a drop',
        url: 'https://help.bottle.com/t/q6h7py4/step-3-creating-drops-reminder-messagesautocharge-times'
      }
    ]
  },
  {
    icon: ClockIcon,
    name: 'Keep track of your orders',
    iconForeground: 'text-teal-700',
    iconBackground: 'bg-teal-50',
    actions: [
      {
        title: 'Explore the activity page',
        url: 'https://help.bottle.com/t/x2h7q71/understanding-the-activity-tab'
      },
      {
        title: 'Understand your reports',
        url: 'https://help.bottle.com/t/60h7q7f/understanding-the-different-report-downloads'
      }
    ]
  },
  {
    icon: ReceiptRefundIcon,
    name: 'Improve customer retention',
    iconForeground: 'text-rose-700',
    iconBackground: 'bg-rose-50',
    actions: [
      { title: 'Offer memberships', url: 'https://help.bottle.com/t/83h7q7p/how-to-setup-membership-tiers' },
      {
        title: 'Create a loyalty program',
        url: 'https://help.bottle.com/t/35h7qb5/how-to-create-a-loyalty-program'
      },
      { title: 'Share discount codes', url: 'https://help.bottle.com/t/q6h7q7t/how-to-setup-a-discount-code' }
    ]
  },
  {
    icon: AcademicCapIcon,
    name: 'Get to know us better',
    iconForeground: 'text-indigo-700',
    iconBackground: 'bg-indigo-50',
    actions: [
      { title: 'Book a dashboard walkthrough', url: 'https://calendly.com/michaelz_bottle/bottle-walkthrough' },
      { title: 'Ask a question over email', url: 'mailto:team@bottle.com' },
      { title: 'Explore our knowledge base', url: 'https://help.bottle.com/' }
    ]
  }
]

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-full py-5 lg:border-t lg:border-white lg:border-opacity-20" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("section", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("h2", {
                  id: "profile-overview-title",
                  class: "sr-only"
                }, "Profile Overview", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        (nameOrHandle.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Welcome, " + _toDisplayString(nameOrHandle.value), 1))
                          : _createCommentVNode("", true),
                        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-base font-medium text-gray-900 leading-4 mt-1" }, " Let's build your customer list and help you start selling. ", -1))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cards, (card, cardIdx) => {
                  return _createElementVNode("div", {
                    key: card.name,
                    class: _normalizeClass([
                    cardIdx === 0 ? 'rounded-tl-lg rounded-tr-lg sm:rounded-tr-none' : '',
                    cardIdx === 1 ? 'sm:rounded-tr-lg' : '',
                    cardIdx === cards.length - 2 ? 'sm:rounded-bl-lg' : '',
                    cardIdx === cards.length - 1 ? 'rounded-bl-lg rounded-br-lg sm:rounded-bl-none' : '',
                    'relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-cyan-500'
                  ])
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", {
                        class: _normalizeClass([
                        card.iconBackground,
                        card.iconForeground,
                        'rounded-lg inline-flex p-3 ring-1 ring-gray-200 mr-4'
                      ])
                      }, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(card.icon), {
                          class: "h-5 w-5",
                          "aria-hidden": "true"
                        }))
                      ], 2),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("h3", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(card.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.actions, (action) => {
                              return (_openBlock(), _createElementBlock("a", {
                                key: action.title,
                                href: action.url,
                                class: "mt-1 text-sm text-gray-500 hover:underline",
                                target: "_blank"
                              }, _toDisplayString(action.title), 9, _hoisted_21))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ], 2)
                }), 64))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

}